import { getRequest, postRequest } from './api';
// 课程列表
export function lessonList(params) {
  const url = 'lesson/index';
  return getRequest(url, Object.assign(params, { plate_id: window.plateId }));
}

// 获取课件列表
export function courseList(params) {
  const url = 'course/index';
  return getRequest(url, params);
}

// 上传学习进度
export function recordSave(params) {
  const url = 'record/save';
  return postRequest(url, params);
}

// 课程通过
export function recordPass(params) {
  const url = 'record/pass';
  return postRequest(url, params);
}

// 课程练习
export function courseExercises(params) {
  const url = 'exercises/index';
  return getRequest(url, params);
}
